import { Component } from '@angular/core';

@Component({
    selector: 'vsc-consumer-information',
    templateUrl: './consumer-information.component.html',
    styleUrls: ['./consumer-information.component.scss'],
    standalone: false,
})
export class ConsumerInformationComponent {
    constructor() {}
}
